import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/root/cpcic-admin-release/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { findComponentUpward } from 'view-design/src/utils/assist';
import { mapState } from 'vuex';
export default {
  computed: _objectSpread({}, mapState('admin/layout', ['menuSiderReload', 'menuHeaderReload'])),
  methods: {
    handleClick: function handleClick(path) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'sider';
      var current = this.$route.path;
      if (current === path) {
        if (type === 'sider' && this.menuSiderReload) this.handleReload();else if (type === 'header' && this.menuHeaderReload) this.handleReload();
      }
    },
    handleReload: function handleReload() {
      var $layout = findComponentUpward(this, 'BasicLayout');
      if ($layout) $layout.handleReload();
    }
  }
};